import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Course API
export const getCourseInfo = () => axios.get(`${API}/courses/info`);
export const getCourseInfoBySlug = (slug) => axios.get(`${API}/courses/info/${slug}`);
export const getCourseCatalog = () => axios.get(`${API}/courses/catalog`);

// Chapter API
export const getChapters = () => axios.get(`${API}/chapters/`);
export const getChapter = (id) => axios.get(`${API}/chapters/${id}`);
export const updateChapterTime = (id, timeSpent) => 
  axios.post(`${API}/chapters/${id}/time`, { time_spent_seconds: timeSpent });
export const completeChapter = (id) => axios.post(`${API}/chapters/${id}/complete`);

// Quiz API
export const getChapterQuiz = (chapterId) => axios.get(`${API}/quizzes/chapter/${chapterId}`);
export const submitQuiz = (data) => axios.post(`${API}/quizzes/submit`, data);
export const getFinalExam = () => axios.get(`${API}/quizzes/final-exam`);
export const submitFinalExam = (data) => axios.post(`${API}/quizzes/final-exam/submit`, data);

// Progress API
export const getProgress = () => axios.get(`${API}/progress/`);

// Payment API
export const createCheckout = (originUrl, discountCode, course = 'bail-enforcement') => 
  axios.post(`${API}/payments/checkout`, { origin_url: originUrl, discount_code: discountCode, course });
export const getPaymentStatus = (sessionId) => axios.get(`${API}/payments/status/${sessionId}`);
export const validateDiscount = (code, course = 'bail-enforcement') => axios.post(`${API}/payments/validate-discount`, { code, course });

// TTS API
export const getTTSAudio = (chapterId, sectionId) => 
  axios.get(`${API}/tts/chapter/${chapterId}/section/${sectionId}`);

// Admin API
export const getStudents = () => axios.get(`${API}/admin/students`);
export const getStudentProgress = (id) => axios.get(`${API}/admin/students/${id}/progress`);
export const getPendingCertificates = () => axios.get(`${API}/admin/certificates/pending`);
export const reviewCertificate = (id, data) => axios.post(`${API}/admin/certificates/${id}/review`, data);
export const getAuditLogs = (params) => axios.get(`${API}/admin/audit-logs`, { params });
export const createDiscountCode = (data) => axios.post(`${API}/admin/discount-codes`, data);
export const getDiscountCodes = () => axios.get(`${API}/admin/discount-codes`);
export const verifyStudentId = (id, approve) => axios.post(`${API}/admin/verify-id/${id}`, null, { params: { approve } });

// Recovery Board API
export const getRecoveryPostings = () => axios.get(`${API}/recovery/postings`);

// ID Upload
export const uploadId = (base64) => axios.post(`${API}/auth/upload-id`, { id_document_base64: base64 });

// Pre-Licensing Course API
export const getPlChapters = () => axios.get(`${API}/pre-licensing/chapters`);
export const getPlProgress = () => axios.get(`${API}/pre-licensing/progress`);
export const getPlChapter = (id) => axios.get(`${API}/pre-licensing/chapters/${id}`);
export const getPlChapterPagesInfo = (id) => axios.get(`${API}/pre-licensing/chapters/${id}/pages/info`);
export const getPlChapterPage = (id, page) => axios.get(`${API}/pre-licensing/chapters/${id}/pages/${page}`);
export const savePlPageProgress = (id, page) => axios.post(`${API}/pre-licensing/chapters/${id}/pages/${page}/save`);
export const updatePlChapterTime = (id, timeSpent) => axios.post(`${API}/pre-licensing/chapters/${id}/time`, { time_spent_seconds: timeSpent });
export const getPlQuiz = (id) => axios.get(`${API}/pre-licensing/chapters/${id}/quiz`);
export const submitPlQuiz = (id, answers, timeTaken) => axios.post(`${API}/pre-licensing/chapters/${id}/quiz/submit`, { answers, time_taken_seconds: timeTaken });
export const completePlChapterNoQuiz = (id) => axios.post(`${API}/pre-licensing/chapters/${id}/complete`);

export default API;
